import React, { Component } from "react";
import "./css/ResultScreenMobile.css";

import CalculateIcon from "./src/Calculator_icon.png";
import ShopImage from "./src/iCon-shop.png";
import SheraImage from "./src/iCon-full.png";

export default class TableInformationMobile extends Component {
  onClickShare = () => {
    // console.log("onClickShare");

    const url =
      "https://www.shera.com/AR/share/" +
      this.props.currentBatten.id +
      "/" +
      this.props.currentFloor.id;

    if (navigator.share) {
      navigator
        .share({
          url: url,
        })
        .then(() => {
          console.log("Sharing successfull");
        })
        .catch(() => {
          console.log("Sharing failed");
        });
    } else {
      alert("Browser does not support share");
    }
  };

  render() {
    return (
      <>
        <div className="container" style={{ letterSpacing: "-1px" }}>
          <div className="row">
            <div className="col-sm-auto">
              <img
                className="resultScreen-mobile-info-body-icon"
                src={
                  this.props.currentMenuSelect === "batten"
                    ? this.props.currentBatten.iconlink
                    : this.props.currentFloor.iconlink
                }
                alt=""
              />
            </div>
            <div className="col">
              <div
                className="resultScreen-mobile-info-header"
                style={{ margin: "0px" }}
              >
                <div className="row header-text">
                  {this.props.currentMenuSelect === "batten"
                    ? this.props.currentBatten.name
                    : this.props.currentFloor.name}
                </div>

                <div
                  className="table-calculator-container"
                  onClick={this.props.onCalculate}
                >
                  <img
                    className="table-calculator-icon"
                    src={CalculateIcon}
                    alt=""
                  />

                  <div className="table-calculator-text">เครื่องคำนวณ</div>
                </div>
              </div>

              <div className="row">
                <table className="table table-borderless">
                  <thead style={{ backgroundColor: "#E6E7E8" }}>
                    <tr>
                      <th scope="col">รุ่น</th>
                      <th scope="col">ลาย</th>
                      <th scope="col">สี</th>
                      <th scope="col">
                        <div>ขนาด (ซม.)</div>
                        <div>(หนา * กว้าง * ยาว)</div>
                      </th>
                      <th scope="col">
                        <div>จำนวน</div>
                        <div>(แผ่น/ตร.ม.)</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{ backgroundColor: "white" }}>
                    {this.props.currentMenuSelect === "batten"
                      ? this.props.dataBatten.map((data) =>
                          data.track === this.props.currentBatten.track ? (
                            <tr key={data.id}>
                              <th scope="col">{data.class}</th>
                              <th scope="col">{data.striped}</th>
                              <th scope="col">{data.color}</th>
                              <th scope="col">{data.size}</th>
                              <th scope="col">{data.numpersqm}</th>
                            </tr>
                          ) : null
                        )
                      : this.props.dataFloor.map((data) =>
                          data.track === this.props.currentFloor.track ? (
                            <tr key={data.id}>
                              <th scope="col">{data.class}</th>
                              <th scope="col">{data.striped}</th>
                              <th scope="col">{data.color}</th>
                              <th scope="col">{data.size}</th>
                              <th scope="col">{data.numpersqm}</th>
                            </tr>
                          ) : null
                        )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "10px",
            }}
          >
            <div className="resultScreen-mobile-info-button-container">
              {/* <div
                className="resultScreen-mobile-btn-left"
                onClick={() =>
                  this.props.onEcommerce(this.props.currentMenuSelect)
                }
              >
                <img
                  className="resultScreen-mobile-menu-image"
                  src={ShopImage}
                  alt=""
                />
                <div className="resultScreen-mobile-menu-text">ซื้อเลย</div>
              </div> */}
              <div
                className="resultScreen-mobile-btn-right"
                onClick={this.onClickShare}
              >
                <img
                  className="resultScreen-mobile-menu-image"
                  src={SheraImage}
                  alt=""
                />
                <div className="resultScreen-mobile-menu-text">แชร์</div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
